import { useTranslation } from "react-i18next";
import TeambookDialog from "../../default_components/TeambookDialog";
import PropTypes from "prop-types";

const RepetitionReachedModal = ({ isOpen, close }) => {
  const { t } = useTranslation();

  return (
    <TeambookDialog
      open={isOpen}
      onClose={close}
      title={t("planning.repetition_reached_title")}
      content={<p style={{margin: 0}}> {t("planning.repetition_reached_text")}</p>}
      withCloseButton
      actionButtons={[
        {
          text: t("got_it"),
          onClick: close,
          id: "gotIt",
        },
      ]}
    />
  );
};

RepetitionReachedModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default RepetitionReachedModal;
